import { createWorkspaceTabNavigator } from "../../WorkspaceTabNavigator";

export type WorkspaceRoutineOccasionTabParamList = {
  WorkspaceRoutineOccasionStatus: undefined;
  WorkspaceRoutineOccasionStatusOverview: undefined;
  WorkspaceRoutineOccasionAnalytics: undefined;
};

export const WorkspaceRoutineOccasionTab =
  createWorkspaceTabNavigator<WorkspaceRoutineOccasionTabParamList>();
